import { CircularProgress } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const ButtonLoader = styled(CircularProgress)``;
